import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';

import { toggleCollapsed, toggleOpened } from '../model/sidebarSlice';

export const useSidebarSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.sidebarReducer),
		toggleCollapsed: () => dispatch(toggleCollapsed()),
		toggleOpened: (isClose?: boolean) => dispatch(toggleOpened(isClose)),
	};
};
